Board = require 'app/scripts/models/board'
CollectionWithHelpers = require 'app/scripts/models/collections/internal/collection-with-helpers'
Util = require 'app/scripts/lib/util'

class BoardList extends CollectionWithHelpers
  model: Board

  initialize: ->
    @listenTo @, 'change:name', @sort
    return

  comparator: (board) ->
    # Sort by org name, then board name

    org = board.getOrganization()
    orgName = org?.get('displayName') || ""
    boardName = board.get('name') || ""
    Util.rpad(orgName, 64).toUpperCase() + boardName.toUpperCase()

module.exports = BoardList
